module.exports = __webpack_public_path__ + "media/images/grail-logo-mobile-736954ec9813a8d85f6d5629c287f9d8.png";